import { compose, withHandlers } from 'recompose';
import onClickOutside from 'react-onclickoutside';
import withToggle from '../../hoc/withToggle';

const HeaderDropdownContainer = compose(
  withToggle(),
  withHandlers({
    handleClickOutside: props => () => {
      if (props.closeOnClickOutside) {
        props.off();
      }
    },
  }),
  onClickOutside,
);

export default HeaderDropdownContainer;
